import Icon from '@/components/common/icons/Icon';
import { IconName } from '@common/react/icons';
import { Button, ButtonProps } from './Button';
import FadeInBox, { FadeInBoxProps } from './FadeInBox';
import { FlexRow } from './Flex';
import IconBackground from './icons/IconBackground';
import { Paragraph } from './Typography';

const Callout = ({
    iconName,
    children,
    cta,
    ...props
}: FadeInBoxProps & {
    iconName?: IconName;
    children: React.ReactNode;
    cta?: {
        text: string;
        props: ButtonProps;
    };
}) => {
    return (
        <FadeInBox
            flexDirection="row"
            bg="gray.50"
            p={6}
            alignItems="center"
            justifyContent="space-between"
            rounded="md"
            {...props}
        >
            <FlexRow alignItems="center" gap={6}>
                {iconName && (
                    <IconBackground shape="circle" bg="white">
                        <Icon name={iconName} />
                    </IconBackground>
                )}
                <Paragraph fontSize="md" color="textMuted" textAlign="left">
                    {children}
                </Paragraph>
            </FlexRow>
            {cta && <Button {...cta.props}>{cta.text}</Button>}
        </FadeInBox>
    );
};

export default Callout;
